import React, { useState, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HttpHelper from '../service/httpService'
import { handleImageError } from 'base/Utility'
import ReactPlayer from 'react-player'
const HomeAboutSection = (props) => {

    const [homeAboutSection, setHomeAboutSection] = useState({});

    const getHomeAboutSection = async () => {
        await HttpHelper.get("Website/GetHomeAboutSection").then((response) => {
            if (response.status === 200) {
                setHomeAboutSection(response.data[0]);
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        getHomeAboutSection();
    }, [])

    function isMobileDevice() {
        const userAgent = navigator.userAgent.toLowerCase();
        return /iphone|ipod|android|blackberry|windows phone|opera mini|iemobile/.test(userAgent);
    }

    return (<>
        <div id="about" className={`section ${props.bgClass} p-10`} style={{ backgroundColor: '#e9e9e9' }}>
            <div className="container">
                <div className="section-title text-center bottom-border-factsheet">
                    <h2 className="title">{homeAboutSection && homeAboutSection.heading}</h2>
                    <p className="sub-title title-w-90 ">{homeAboutSection && homeAboutSection.subHeading}</p>
                </div>
                <div className="row">
                    <div className="col-xl-4 col-lg-4 col-12 align-item-vertical-center">
                        <div className="alignImages">
                            {

                                homeAboutSection && homeAboutSection.file != null ?
                                    homeAboutSection.file.fileType == ".mp4" ?
                                        <ReactPlayer url={homeAboutSection.file.fileUrl}
                                            config={{ file: { attributes: { controlsList: 'nodownload', onContextMenu: e => e.preventDefault() } } }} width="100%" height="100%" controls={true} playing={isMobileDevice() ? false : true} muted={true} loop={true} />
                                        :
                                        <img className="resize-image" src={`${homeAboutSection.file.fileUrl}`} effect="blur" height="200" onError={handleImageError} />
                                    :
                                    <ReactPlayer url="https://www.youtube.com/watch?v=_47u-mFqsKQ"
                                        config={{ file: { attributes: { controlsList: 'nodownload', onContextMenu: e => e.preventDefault() } } }} width="100%" height="100%" controls={true} playing={isMobileDevice() ? false : true} muted={true} loop={true} />
                            }
                        </div>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-12 align-item-vertical-center">
                        <div className="ml-xl-10 text-left" dangerouslySetInnerHTML={{ __html: homeAboutSection && homeAboutSection.content }}></div>
                    </div>

                </div></div>
        </div>
    </>)
}

export default HomeAboutSection;